import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import {
  OneOfFilterDataGrid,
  StringFilterDataGrid,
} from 'app/common/ui/data-grid/filters';
import { appRoute } from 'app/railways/router/routes';

import { TUser } from '../../core/user';

export const cols: TEntityGridColumn<TUser>[] = [
  {
    field: 'id',
    // type: 'rightAligned',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const path = appRoute.USER.DETAILS.buildPath({
        id: value,
      });

      return <Link to={path}>{value}</Link>;
    },
    filter: StringFilterDataGrid({
      filterName: 'id',
      placeholder: 'Введите ID пользователя',
    }),
  },
  {
    field: 'login',
    // type: 'rightAligned',
    headerName: 'Логин',
    minWidth: 50,
    colId: 'login',
    sortable: false,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TUser }) => {
      const path = appRoute.USER.DETAILS.buildPath({
        id: data.id,
      });

      return <Link to={path}>{data.login}</Link>;
    },
    filter: StringFilterDataGrid({
      filterName: 'login',
      placeholder: 'Введите Логин пользователя',
    }),
  },
  {
    field: 'blocked',
    headerName: 'Статус блокировки',
    colId: 'blocked',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: boolean }) =>
      value ? 'Заблокирован' : 'Активен',
    filter: OneOfFilterDataGrid({
      filterName: 'blocked',
      options: [
        { label: 'Заблокирован', value: 1 },
        { label: 'Активен', value: 0 },
      ],
    }),
  },
];
